import type { IAuthProvider } from "./types";
import { nativeAuthProvider } from "./nativeAuthProvider";
import { BrowserAuthProvider } from "./browserAuthProvider";
import { isNativeApp, isNativeAppSsoEnabled } from "./nativeAuth";

/**
 * Central auth provider selection logic.
 *
 * - Native wrapper with SSO enabled => native provider
 * - Otherwise => browser MSAL provider
 */
export const authProvider: IAuthProvider =
	isNativeApp() && isNativeAppSsoEnabled() ? nativeAuthProvider : new BrowserAuthProvider();
